import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt-br";
import { useParams } from "react-router-dom";

const NewsReadMore = () => {
  const [news, setNews] = useState([]);

  let { titulo } = useParams();

  if (titulo.startsWith('"')) titulo = titulo.substr(1, titulo.length);
  if (titulo.endsWith('"')) titulo = titulo.substr(0, titulo.length - 1);

  async function exibir() {
    const payload = apiGet("/news/api/titulo?titulo=" + titulo);
    const data = (await payload).data.data;
    return data;
  }

  useEffect(() => {
    exibir().then(
      (data) => {
        if (data != null) setNews(data);
        else {
          setNews({ title: "Nenhuma notícia para exibir." });
        }
      },
      () => {
        console.debug("error");
        setNews({ title: "Nenhuma notícia para exibir." });
      }
    );
  }, []);

  return (
    <div>
      <section id="posts container">
        <div class="row mx-5 d-flex justify-content-center pt-3 post">
          <div class="col-md-12">
            <div class="row md-5 justify-content-center text-center">
              <h2>{news.title}</h2>
            </div>
            <div class="row mx-5 justify-content-center text-center">
              <p class="card-text m-0">
                <small class="text-muted">{news.authors}</small> <br />
                <small class="text-muted">
                  {moment(news.date).format("LL")}
                </small>
              </p>
            </div>
            <div class="row mx-5 my-5">
              <div dangerouslySetInnerHTML={{ __html: news.description }}></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewsReadMore;
